export function switchRegex(
  text: string,
  cases: [RegExp | null, (matches: RegExpMatchArray) => string | void][],
  isAll: boolean = false
): string {
  for (const [reg, callback] of cases) {
    if (!reg) {
      return callback(['']) || '';
    }
    const results = text.match(reg);
    if (results) {
      const res = callback(results);
      if (!isAll) {
        return res || '';
      }
    }
  }
  return '';
}
